import NetworkBackground from '../NetworkBackground';
import styles from './Onboarding.module.css';

const STEPS = [
  { key: 'account', label: 'Account' },
  { key: 'verify', label: 'Verify' },
  { key: 'company', label: 'Company' },
  { key: 'team', label: 'Team' },
  { key: 'trial', label: 'Trial' },
];

function Stepper({ current }) {
  const at = current === 'done' ? STEPS.length : STEPS.findIndex((s) => s.key === current);
  return (
    <ol className={styles.stepper} aria-label="Sign up progress" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {STEPS.map((s, i) => (
        <li
          key={s.key}
          aria-current={i === at ? 'step' : undefined}
          className={`${styles.stepperItem} ${i === at ? styles.stepperActive : ''} ${i < at ? styles.stepperDone : ''}`}
        >
          <span className={styles.stepperDot}>{i < at ? '✓' : i + 1}</span>
          {s.label}
          {i < STEPS.length - 1 && <span className={styles.stepperLine} />}
        </li>
      ))}
    </ol>
  );
}

// Page frame shared by every sign-up step: background, progress, card and footer.
export default function AuthShell({ step, brand = true, icon, title, subtitle, children }) {
  return (
    <div className={styles.pageWrapper}>
      <NetworkBackground />
      <Stepper current={step} />
      <div className={styles.card}>
        {brand && (
          <div className={styles.brand}>
            <img src="/logo.png" alt="Nodel logo" className={styles.logo} />
            <p className={styles.slogan}>Organize. Schedule. Deliver.</p>
          </div>
        )}
        {icon && <div className={styles.doneIcon} aria-hidden="true">{icon}</div>}
        {title && <h1 className={styles.title}>{title}</h1>}
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {children}
      </div>
      <div className={styles.poweredBy}>
        Powered by Nodel · <a href="mailto:sales@nodel.co.za">Help</a>
      </div>
    </div>
  );
}
